import styled from "styled-components";
import { BurgerMenuWidth } from "./components/core/AppBurgerMenu/AppBurgerMenu.styles";

export const StyledAppLoggedInContainer = styled.div({
  "@media only screen and (min-width: 1200px)": {
    width: `calc(100% - (${BurgerMenuWidth}))`,
    marginLeft: BurgerMenuWidth,
  },
});
